import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';

const LogoBox = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };

        render() {
            const {
                content: { titlePic, qrcodePic },
            } = this.props;

            return (
                <div className={styles.box}>
                    <div className={styles.titleBox}>
                        <img src={titlePic} />
                    </div>
                    <div className={styles.qr_pic}>
                        <img src={qrcodePic} />
                    </div>
                </div>
            );
        }
    },
);

export default LogoBox;
